import DynamicImage from "@ds/components/DynamicImage";
import useStyles from "./styles";
import { IMG_PLAY } from "@config/images";
import { useEffect } from "react";

interface Image {
  mediaId: string;
  mediaName: string;
  mediaPath: string;
}

interface IYoutubePlayer {
  image: Image;
  productYoutubeId: string;
}

const YoutubePlayer = (props: IYoutubePlayer) => {
  const { image, productYoutubeId } = props;
  const styles = useStyles();

  const loadPlayer = (event: Event) => {
    if (typeof window !== "undefined") {
      const target = event.currentTarget as HTMLDivElement;
      const iframe = document.createElement("iframe");

      iframe.height = String(target.clientHeight);
      iframe.width = String(target.clientWidth);
      iframe.src = "https://www.youtube.com/embed/" + target.dataset.videoId + "?autoplay=1";
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute(
        "allow",
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      );
      iframe.setAttribute("allowFullScreen", "");
      iframe.setAttribute("title", "Embedded youtube");

      document.getElementById("play")?.remove();

      const firstChild = target.firstElementChild;
      firstChild ? target.replaceChild(iframe, firstChild) : target.appendChild(iframe);
    }
  };

  useEffect(() => {
    const players = document.querySelector("#youtube-player");
    players?.addEventListener("click", loadPlayer, { once: true });

    return () => players?.removeEventListener("click", loadPlayer);
  }, []);

  return (
    <div className={styles.youtubePlayer} id="youtube-player" data-video-id={productYoutubeId}>
      <img src={IMG_PLAY} className={styles.play} id="play" alt="play" />
      <DynamicImage
        id="image-cover"
        borderRadius={6}
        priority
        src={image.mediaPath}
        alt={image.mediaName}
      />
    </div>
  );
};

export default YoutubePlayer;
